import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HsgRouteGuardService } from '@hhsg/hsg-asc';

import { AdminComponent } from './admin.component';
import { ClientImpersonationComponent } from './client-impersonation/client-impersonation.component';
import { FacilityComponent } from './facility/facility.component';
import { JobTitleComponent } from './job-title/job-title.component';
import { MeasuresComponent } from './measures/measures.component';
import { UserComponent } from './user/user.component';
import { VarianceReasonComponent } from './variance-reason/variance-reason.component';
import { WorkforceRouteGuardService } from '../../workforce-route-guard.service';
import { UnitsOfServiceComponent } from './units-of-service/units-of-service.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { ClientConfigurationComponent } from './client-configuration/client-configuration.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: '',
				component: AdminComponent,
				children: [
					{ path: 'client-impersonation', component: ClientImpersonationComponent, canActivate: [HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'client-configuration', component: ClientConfigurationComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'facility', component: FacilityComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'job-title', component: JobTitleComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'measures', component: MeasuresComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'user', component: UserComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService] },
					{ path: 'variance-reason', component: VarianceReasonComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'units-of-service', component: UnitsOfServiceComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] },
					{ path: 'procedure', component: ProcedureComponent, canActivate: [ HsgRouteGuardService, WorkforceRouteGuardService ] }										
				]
			}
		])
	],
	exports: [RouterModule]
})
export class AdminRoutingModule {
}
